import MDinput from '@/components/MDinput';

export function getFormDefinition(vue) {
  const validateRequire = function(rule, value, callback) {
    if (!value) {
      callback(new Error(vue.$i18n.t('validation.required')));
    } else {
      callback();
    }
  };
  return {
    id: {
      type: MDinput,
      defaultValue: '',
      props: {
        caption: 'language.code',
        maxlength: 2,
        textTransform: 'lowercase',
        required: true
      },
      rules: [
        {
          validator: validateRequire
        }
      ]
    },
    description: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 255,
        required: true
      },
      rules: [
        {
          validator: validateRequire
        }
      ]
    }
  };
}
export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
